module.exports = __webpack_public_path__ + "static/D365-service-management-dae3ce0ace138acd1eb04a53baabe715.png";